import {
  ShippingMarginOverTimeRequestSchema,
  ShippingMarginOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getShippingMarginOverTime = {
  name: "getShippingMarginOverTime" as const,
  input: ShippingMarginOverTimeRequestSchema,
  output: ShippingMarginOverTimeResponseSchema,
};
